// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification_container__CaGAR {
  position: fixed;
  top: 60px;
  left: calc(50% - 200px);
  width: 400px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  z-index: 9999;
  opacity: 0;
  animation: notification_fade-in-out__pbWRC 2s linear forwards; }
  .notification_container__CaGAR span {
    margin-left: 10px; }

.notification_containerLil__lD0Rd {
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 4px;
  font-weight: 400;
  font-size: 16px;
  line-height: 175%;
  z-index: 9999;
  opacity: 0;
  animation: notification_fade-in-out__pbWRC 2s linear forwards; }
  .notification_containerLil__lD0Rd span {
    margin-left: 10px; }

@keyframes notification_fade-in-out__pbWRC {
  0% {
    opacity: 0; }
  10% {
    opacity: 1; }
  90% {
    opacity: 1; }
  100% {
    opacity: 0; } }

.notification_good__4XO28 {
  background: #e3f3d0;
  border: 2px solid #87bc45;
  color: #629424; }

.notification_bad__ya\\+w9 {
  background: #f6cbcb;
  border: 2px solid #e00606;
  color: #B00808; }
`, "",{"version":3,"sources":["webpack://./src/components/notification/notification.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,6DAAyC,EAAA;EAf3C;IAiBI,iBAAiB,EAAA;;AAGrB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,6DAAyC,EAAA;EAZ3C;IAcI,iBAAiB,EAAA;;AAGrB;EACE;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA,EAAA;;AAId;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc,EAAA;;AAGhB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc,EAAA","sourcesContent":[".container {\n  position: fixed;\n  top: 60px;\n  left: calc(50% - 200px);\n  width: 400px;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  z-index: 9999;\n  opacity: 0;\n  animation: fade-in-out 2s linear forwards;\n  span{\n    margin-left: 10px;\n  }\n}\n.containerLil {\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  border-radius: 4px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 175%;\n  z-index: 9999;\n  opacity: 0;\n  animation: fade-in-out 2s linear forwards;\n  span{\n    margin-left: 10px;\n  }\n}\n@keyframes fade-in-out {\n  0% {\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.good {\n  background: #e3f3d0;\n  border: 2px solid #87bc45;\n  color: #629424;\n\n}\n.bad {\n  background: #f6cbcb;\n  border: 2px solid #e00606;\n  color: #B00808;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `notification_container__CaGAR`,
	"fade-in-out": `notification_fade-in-out__pbWRC`,
	"containerLil": `notification_containerLil__lD0Rd`,
	"good": `notification_good__4XO28`,
	"bad": `notification_bad__ya+w9`
};
export default ___CSS_LOADER_EXPORT___;
